import { SupportedPlansType } from 'api/billing/types';
import { useAccountDataQuery } from 'queries/account';
import { isLocalhost } from 'utils/is-localhost';
import { isNitroEnvironment, isOrbitsEnvironment } from 'utils/is-nitro-env';

export const useIsAccountInEnterpriseBillingType = (): boolean => {
  const { data: accountData } = useAccountDataQuery();

  if (isNitroEnvironment() || isLocalhost() || isOrbitsEnvironment()) {
    return true;
  }

  const value =
    accountData?.billingMeta?.subscription?.plan?.planType ===
      SupportedPlansType.Enterprise.toUpperCase() ||
    accountData?.billingMeta?.subscription?.plan?.planType ===
      SupportedPlansType['Enterprise-V2'].toUpperCase();

  return value;
};

export const useIsAccountInPremiumBillingType = (): boolean => {
  const { data: accountData } = useAccountDataQuery();

  const value =
    accountData?.billingMeta?.subscription?.plan?.planType ===
      SupportedPlansType.Premium.toUpperCase() ||
    accountData?.billingMeta?.subscription?.plan?.planType ===
      SupportedPlansType['Premium-V2'].toUpperCase();

  return value;
};
